module.exports = __webpack_public_path__ + "static/media/classes-sc.c0f73b57.png";